import i18n from '@/i18n';

/** The rank title for a level in the UI language (globe:rank.N), falling back to the API's English name. */
export function rankName(level: number, fallback: string): string {
  return i18n.t(`globe:rank.${level}`, { defaultValue: fallback });
}
